<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Payroll' [canGoBack]="true" [canRefresh]="true" 
        [subTitle]="'Break' + (vm?.payrollBreakVm?.payrollDate ? ' - ' + vm.payrollBreakVm.payrollDate : '')"
        (refreshClick)="refreshPage()"></app-page-header>

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">
        <div *ngIf="vm.payrollBreakVm as ts">
            <div class="row pt-3">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header title="Info"
                            [headingSize]="6"></app-card-header>
                        <mdb-card-body cascade="true">
                            <div class="row mt-n4 mb-n4">
                                <div class="col-md-4">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm text-right">
                                            Break Start Time:
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm text-left">
                                            <app-form-input [vm]="vm.breakFormVm.breakTimeStartVm"
                                                (textChanged)="breakTimeChanged(vm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4">
                                <div class="col-md-4">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm text-right">
                                            Break End Time:
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm text-left">
                                            <app-form-input [vm]="vm.breakFormVm.breakTimeEndVm"
                                                (textChanged)="breakTimeChanged(vm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2 mb-1" *ngIf="vm.updateMessage && vm.updateMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-center">
                                    <span class="text-success">{{ vm.updateMessage }}</span>
                                </div>
                            </div>
                            <div class="row mt-2 mb-1" *ngIf="vm.errorMessage && vm.errorMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-center">
                                    <span class="text-danger">{{ vm.errorMessage }}</span>
                                </div>
                            </div>
                            <div class="row mt-2 mb-1">
                                <div class="col-md-6 mt-2 d-flex justify-content-center">
                                    <button style="margin-top:-5px; width: 100px;" mdbBtn type="button"
                                        color="danger" rounded="true" outline="true" size="sm" mdbWavesEffect
                                        class="btn-block" (click)="deleteBreakClicked(vm)" [disabled]="!vm.breakId">
                                        Delete
                                    </button>
                                </div>
                                <div class="col-md-6 mt-2 d-flex justify-content-center">
                                    <button style="margin-top:-5px; width: 150px;" mdbBtn type="button"
                                        color="info" rounded="true" outline="true" size="sm" mdbWavesEffect
                                        class="btn-block" (click)="updateBreakClicked(vm)" [disabled]="!vm.validInput">
                                        Update
                                    </button>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
</div>